import React from 'react';
import { TabsContent } from "../styles";

class TabsAdvisorSuccessor extends React.Component {
    render() {
        return (
            <TabsContent>
                {this.props.advisor}
            </TabsContent>
        )
    }
}

export default TabsAdvisorSuccessor;